// src/i18n/en/hmis.js
const hmis = {
    name: 'HMI Device |||| HMI Devices',
    titles: {
        list: 'HMI Devices',
        create: 'Create New HMI',
        edit: 'Edit HMI',
        show: 'HMI Details',
        details: 'View details'
    },
    sections: {
        create: 'New HMI'
    },
    fields: {
        name: 'Device Name',
        device_id: 'Device ID',
        deviceId: 'Device ID',
        type: 'Type',
        zone: 'Zone',
        hotel: 'Hotel',
        status: 'Status',
        last_seen: 'Last Connection',
        lastSeen: 'Last Connection',
        lastSeenAt: 'Last Connection',
        controller_address: 'Controller Address',
        controllerIpAddress: 'Controller IP',
        controllerTcpPort: 'TCP Port',
        isActive: 'Active',
        isOnline: 'Online',
        createdAt: 'Created at',
        updatedAt: 'Last updated',
        provisioning_code: 'Provisioning Code',
        provisioningCode: 'Provisioning Code',
        expires_at: 'Expires at',
        provisioningCodeExpiresAt: 'Code expires at',
        hasProvisioningCode: 'Has provisioning code',
        initialApiKey: 'Initial API Key',
        initial_api_key_available: 'API Key available on creation'
    },
    types: {
        tablet: 'Tablet',
        kiosk: 'Kiosk',
        unknown: 'Unknown'
    },
    status: {
        online: 'Online',
        offline: 'Offline',
        disconnected: 'Disconnected',
        never_connected: 'Never connected',
        active: 'Active',
        inactive: 'Inactive',
        expired: 'Expired',
        no_code: 'No code',
        code_active: 'Active Code',
        code_expired: 'Expired Code',
        just_now: 'Just now',
        minutes_ago: '%{minutes} min ago',
        hours_ago: '%{hours} h ago',
        never: 'Never'
    },
    actions: {
        create: 'Create HMI',
        edit: 'Edit',
        delete: 'Delete',
        view: 'View details',
        show: 'View details',
        generate_provisioning_code: 'Generate Code',
        generate_code: 'Generate Provisioning Code',
        configure: 'Configure',
        refresh: 'Refresh Status',
        copy_code: 'Copy Code',
        reset_api_key: 'Reset API Key',
        provision: 'Provision'
    },
    search: {
        placeholder: 'Search...',
        zone_placeholder: 'Search by zone...',
        device_placeholder: 'Search HMI devices...'
    },
    labels: {
        security_config: 'Security Configuration',
        device_info: 'Device Information',
        provisioning_status: 'Provisioning Status',
        network_config: 'Network Configuration'
    },
    filters: {
        zone: 'Zone',
        type: 'Type',
        status: 'Status',
        all_zones: 'All zones',
        all_types: 'All types',
        all_statuses: 'All statuses',
        search: 'Search'
    },
    dialogs: {
        delete: {
            title: 'Delete HMI %{name}',
            content: 'Are you sure you want to delete HMI "%{name}"?',
            confirm: 'Delete',
            cancel: 'Cancel'
        },
        generate_provisioning_code: {
            title: 'Generate Provisioning Code',
            content: 'A new provisioning code will be generated for this device.',
            confirm: 'Generate',
            cancel: 'Cancel'
        },
        provisioning_confirmation: {
            title: 'Confirm Code Generation',
            warning: 'This action will generate a new provisioning code and invalidate any previous unused code.',
            question: 'Are you sure you want to continue?',
            cancel: 'Cancel',
            confirm: 'Generate Code'
        },
        provisioning_code: {
            title: 'Provisioning Code',
            label: 'Provisioning Code',
            expires: 'This code expires on: %{date}',
            regenerate: 'Regenerate',
            close: 'Close',
            error: 'Could not generate provisioning code'
        }
    },
    messages: {
        no_permission_create: 'Only SuperAdmins can create new HMIs',
        creation_success: 'HMI created successfully',
        create_success_with_key: 'HMI created successfully',
        update_success: 'HMI updated successfully',
        delete_success: 'HMI deleted successfully',
        code_generated: 'Provisioning code generated successfully',
        code_copied: 'Code copied to clipboard',
        loading: 'Loading...',
        no_data: 'No HMI devices available',
        security_superadmin_only: 'Only SuperAdmins can manage security configuration.'
    },
    warnings: {
        code_expiration: 'This code will expire in 30 minutes. Use it immediately to provision the device.',
        unsaved_changes: 'You have unsaved changes. Are you sure you want to leave?',
        code_expired_regenerate: 'The provisioning code has expired. Generate a new one to allow device configuration.',
        delete_warning: 'This action cannot be undone.'
    },
    errors: {
        code_generation_failed: 'Failed to generate provisioning code',
        creation_failed: 'Failed to create HMI',
        update_failed: 'Failed to update HMI',
        delete_failed: 'Failed to delete HMI',
        load_failed: 'Failed to load data',
        permission_denied: 'You do not have permission to perform this action'
    },
    help: {
        provisioning_instructions: 'Use this code on the HMI device to complete the provisioning process. The code expires in 30 minutes.',
        device_id_help: 'Unique device identifier (3-50 characters, letters, numbers, hyphens and underscores only)',
        name_help: 'Descriptive device name (2-100 characters)'
    },
        validation: {
        name_required: 'Device name is required',
        name_min_length: 'Name must be at least 2 characters',
        name_max_length: 'Name cannot exceed 100 characters',
        device_id_required: 'Device ID is required',
        device_id_invalid: 'Device ID must be 3-50 characters and contain only letters, numbers, hyphens and underscores',
        type_required: 'Device type is required',
        zone_required: 'Zone is required',
        hotel_required: 'Hotel is required'
    },
    ui: {
        device_information: 'Device Information',
        security_configuration: 'Security Configuration',
        connection_status: 'Connection Status',
        last_connection: 'Last Connection',
        device_type: 'Device Type',
        provisioning_status: 'Provisioning Status',
        api_management: 'API Management',
        refresh_status: 'Refresh Status'
    },
    notifications: {
        provisioning_code_generated: 'Provisioning code generated successfully',
        provisioning_code_error: 'Error generating provisioning code',
        code_copied: 'Code copied to clipboard',
    }
};

export default hmis;